export default __webpack_public_path__ + "static/media/Virtual Exhibition.23f717c1.JPG";